import { useStaticQuery, graphql } from "gatsby"
import { DetermineSlugLocale } from "../utils/locale"

function UseStoryBlogData(locale) {
  const results = useStaticQuery(
    graphql`
      query GetStoryItems {
        allStoryblokEntry(
          filter: {field_component: {eq:"story"}}
        ) {
          edges {
            node {
              id
              name
              full_slug
              field_component
              uuid
              content
            }
          }
        }
      }
    `
  )

  const stories = []
  results.allStoryblokEntry.edges.forEach((edge)=>{
    let content = JSON.parse(edge.node.content)
    let storyLocale = DetermineSlugLocale(edge.node.full_slug)
    if(!locale || storyLocale === locale) {
      stories.push({
        uuid: edge.node.uuid,
        ...content,
        link: rewriteSlug(edge.node.full_slug)
      })
    }
  })

  return stories
}


function rewriteSlug(slug) {
  const defaultLanguage = 'en/'
  let newSlug = slug
  // replaces /de/home with /de
  newSlug = newSlug.replace('home', '')
  // replaces /en/blog/first-post with /blog/first-post
  newSlug = newSlug.replace(defaultLanguage, '')
  // Normalize leading and trailing slashes
  if(!newSlug.startsWith('/')) {
    newSlug = `/${newSlug}`
  }
  // if(newSlug.endsWith('/')) {
  //   newSlug = newSlug.substring(0,newSlug.length-1)
  // }
  // if(newSlug === ""){
  //   return "/"
  // }
  return newSlug
}
export default UseStoryBlogData